import {
  ALL_LANGUAGES_QUERY,
  LANGUAGE_BY_VALUE_QUERY,
} from '@src/gql/language-gql';
import { LogManager } from '@src/utility/Logger';

import type { Language } from '@src/types.ts/language';
import type { GraphQLClient } from 'graphql-request';

export class LanguageRepository {
  private logger = LogManager.getLogger('repository:LanguageRepository');
  private cached: Language[] | null = null;

  constructor(private gqlClient: GraphQLClient) {}

  async getAllActiveLanguages(): Promise<Language[]> {
    if (this.cached) return this.cached;
    try {
      const response = (await this.gqlClient.request(ALL_LANGUAGES_QUERY)) as {
        allLanguages: Language[];
      };
      this.cached = response.allLanguages;
      return this.cached;
    } catch (err) {
      this.logger.error('Failed to load languages', err);
      return [];
    }
  }

  async getLanguageByValue(value: string): Promise<Language | null> {
    try {
      const response = (await this.gqlClient.request(LANGUAGE_BY_VALUE_QUERY, {
        value,
      })) as { language: Language | null };
      return response.language;
    } catch (err) {
      this.logger.error('Failed to load language by value', { value, err });
      return null;
    }
  }
}
